import { createSelector } from 'reselect'
import initialState from 'SRC/modules/redux/initialState'

export const getPagination = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.list && state.vehicleParts.list.pagination
    ? state.vehicleParts.list.pagination : state.vehicleParts.list.pagination,
  params => params
)
